// PREMIUM SCROLL CHOREOGRAPHY - Sophisticated animations throughout

if (typeof gsap !== 'undefined') {
  gsap.registerPlugin(ScrollTrigger);

  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  if (!prefersReducedMotion) {
    // ===== PARALLAX DEPTH =====
    gsap.utils.toArray('[data-parallax]').forEach((element) => {
      gsap.to(element, {
        y: (i) => -i * 100,
        ease: 'none',
        scrollTrigger: {
          trigger: element,
          start: 'top center',
          end: 'bottom center',
          scrub: 1,
          markers: false,
        },
      });
    });

    // ===== STAGGERED REVEAL ANIMATION =====
    gsap.utils.toArray('[data-reveal]').forEach((element, index) => {
      gsap.from(element, {
        opacity: 0,
        y: 80,
        duration: 1,
        ease: 'power3.out',
        scrollTrigger: {
          trigger: element,
          start: 'top 85%',
          toggleActions: 'play none none none',
          markers: false,
        },
        delay: index * 0.15,
      });
    });

    // ===== SCALE & BLUR REVEAL =====
    gsap.utils.toArray('[data-scale-reveal]').forEach((element) => {
      gsap.from(element, {
        opacity: 0,
        scale: 0.85,
        filter: 'blur(20px)',
        duration: 1.2,
        ease: 'back.out',
        scrollTrigger: {
          trigger: element,
          start: 'top 80%',
          toggleActions: 'play none none none',
          markers: false,
        },
      });
    });

    // ===== SMOOTH COUNTER ANIMATIONS =====
    gsap.utils.toArray('[data-counter]').forEach((counter) => {
      const finalValue = parseInt(counter.textContent);
      let hasAnimated = false;

      ScrollTrigger.create({
        trigger: counter,
        start: 'top 80%',
        onEnter: () => {
          if (!hasAnimated) {
            gsap.to(
              { value: 0 },
              {
                value: finalValue,
                duration: 2.5,
                ease: 'power2.out',
                onUpdate: function () {
                  counter.textContent = Math.floor(this.targets()[0].value);
                },
              }
            );
            hasAnimated = true;
          }
        },
      });
    });

    // ===== PREMIUM HOVER EFFECTS =====
    gsap.utils.toArray('[data-hover-lift]').forEach((element) => {
      element.addEventListener('mouseenter', () => {
        gsap.to(element, {
          y: -12,
          boxShadow: '0 30px 60px rgba(0, 0, 0, 0.12)',
          duration: 0.4,
          ease: 'power2.out',
        });
      });

      element.addEventListener('mouseleave', () => {
        gsap.to(element, {
          y: 0,
          boxShadow: '0 10px 40px rgba(0, 0, 0, 0.08)',
          duration: 0.4,
          ease: 'power2.out',
        });
      });
    });

    // ===== TEXT UNDERLINE ANIMATION =====
    gsap.utils.toArray('[data-underline-hover]').forEach((element) => {
      element.addEventListener('mouseenter', () => {
        gsap.to(element, {
          backgroundPosition: '0% 100%',
          duration: 0.4,
          ease: 'power2.out',
        });
      });

      element.addEventListener('mouseleave', () => {
        gsap.to(element, {
          backgroundPosition: '100% 100%',
          duration: 0.4,
          ease: 'power2.out',
        });
      });
    });

    // ===== SCROLL-TRIGGERED SPLIT TEXT =====
    gsap.utils.toArray('[data-split-reveal]').forEach((element) => {
      const text = element.textContent;
      element.innerHTML = text
        .split('')
        .map((char) => `<span class="char">${char}</span>`)
        .join('');

      gsap.from(element.querySelectorAll('.char'), {
        opacity: 0,
        y: 20,
        duration: 0.6,
        stagger: 0.02,
        ease: 'power2.out',
        scrollTrigger: {
          trigger: element,
          start: 'top 80%',
          toggleActions: 'play none none none',
          markers: false,
        },
      });
    });

    // ===== FADE + SLIDE CHOREOGRAPHY =====
    gsap.utils.toArray('[data-fade-slide]').forEach((element) => {
      const tl = gsap.timeline({
        scrollTrigger: {
          trigger: element,
          start: 'top 75%',
          toggleActions: 'play none none none',
          markers: false,
        },
      });

      tl.from(element, {
        opacity: 0,
        duration: 0.8,
        ease: 'power2.out',
      }).from(
        element,
        {
          y: 60,
          duration: 1,
          ease: 'power3.out',
        },
        0
      );
    });

    // ===== SMOOTH SCROLL TO ANCHOR =====
    gsap.utils.toArray('a[href^="#"]').forEach((anchor) => {
      anchor.addEventListener('click', (e) => {
        const target = document.querySelector(anchor.getAttribute('href'));
        if (target) {
          e.preventDefault();
          gsap.to(window, {
            scrollTo: {
              y: target,
              autoKill: false,
            },
            duration: 1.2,
            ease: 'power3.inOut',
          });
        }
      });
    });

    // ===== MOBILE OPTIMIZATION =====
    if (window.innerWidth < 768) {
      gsap.globalTimeline.clear();
      // Lighter animations on mobile
      gsap.utils.toArray('[data-reveal]').forEach((element) => {
        gsap.from(element, {
          opacity: 0,
          duration: 0.6,
          ease: 'power2.out',
          scrollTrigger: {
            trigger: element,
            start: 'top 85%',
            toggleActions: 'play none none none',
          },
        });
      });
    }
  }
}
